import React from 'react';
import profile from '../../media/profile.png';
import { Card, Col } from 'react-bootstrap';
import Rating from 'react-rating';
import useAuth from '../../hooks/useAuth';
import { useLocation } from 'react-router-dom';



const Review = ({ review, handleDeleteReview }) => {
    const { user } = useAuth();
    const location = useLocation();

    return (
        <Col>
            <Card style={{ minHeight: '300px', maxHeight: '300px', overflow: 'scroll' }} className="mx-2">
                <Card.Body>
                    <div className="d-flex align-items-center text-start">

                        <img className="img-fluid rounded-circle" src={
                            review.photoURL
                                ?
                                review.photoURL
                                :
                                profile
                        } alt="" style={{ width: 48, height: 48 }}
                        ></img>

                        <Card.Title className="ms-3 my-0">
                            <small className="m-0">{review.name}</small>
                            <br />
                            <Rating
                                className="me-1"
                                initialRating={review.rating}
                                emptySymbol="far fa-star icon-color"
                                fullSymbol="fas fa-star icon-color"
                                readonly
                            ></Rating>
                        </Card.Title>

                        {
                            location.pathname === '/dashboard/reviews'
                            &&
                            <>
                                <button onClick={() => {
                                    handleDeleteReview(review._id)
                                }} type="button" className="btn btn-outline-danger btn-circle btn-lg btn-circle ms-auto"><i className="fa fa-trash"></i> </button>

                            </>
                        }
                    </div>
                    <hr />
                    <Card.Text className="text-start">
                        {review.review}
                    </Card.Text>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default Review;